// extracted by mini-css-extract-plugin
module.exports = {"container":"sticky-mini-card_container__wTX9P","img":"sticky-mini-card_img__yqT88","title":"sticky-mini-card_title__XZLFb","date":"sticky-mini-card_date__FT5Zz"};